import React from 'react';
import { motion } from 'framer-motion';
interface CaseStudySectionProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  activities?: string[];
  background?: 'white' | 'gray' | 'blue';
  className?: string;
  id?: string;
}
export function CaseStudySection({
  children,
  title,
  subtitle,
  activities,
  background = 'white',
  className = '',
  id
}: CaseStudySectionProps) {
  const bgColors = {
    white: 'bg-white',
    gray: 'bg-slate-50',
    blue: 'bg-gradient-to-br from-[#4A90E2]/10 to-[#7CB9E8]/10'
  };
  return <section id={id} className={`py-20 md:py-32 ${bgColors[background]} ${className}`} data-id="element-37">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-24" data-id="element-38">
        {(title || subtitle) && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 max-w-3xl" data-id="element-39">
            {title && <h2 className="mb-4 text-3xl font-bold text-slate-900 md:text-4xl lg:text-5xl" data-id="element-40">
                {title}
                <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '80px'
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="mt-4 h-1.5 bg-blue-500" data-id="element-41" />
              </h2>}
            {subtitle && <p className="text-xl text-slate-600 md:text-2xl leading-relaxed" data-id="element-42">
                {subtitle}
              </p>}
            {activities && activities.length > 0 && <div className="flex flex-wrap gap-2 mt-6" data-id="element-43">
                {activities.map((activity, index) => <motion.span key={activity} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4 + index * 0.05,
            duration: 0.3
          }} className="px-2 py-1 text-xs font-medium text-slate-600 bg-slate-100 rounded-full border border-slate-200" data-id="element-44">
                    {activity}
                  </motion.span>)}
              </div>}
          </motion.div>}

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-45">
          {children}
        </motion.div>
      </div>
    </section>;
}